import type { T_OptionalKeys } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import { Empty, Unsupported } from './contingency.jsx';
import { Settings } from './settings/index.js';
import type { Props } from './types.js';

/** @internal */
const Inner = (props: Props): ReactElement => <Settings {...props} />;

/** @internal */
const Guard = ({ ...props }: Props): ReactElement => {
  const isSupported = true; // @fixme - how do we know if this video device supports settings?

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return isSupported ? <Inner {...props} /> : <Unsupported />;
};

/** `<Image>` panel component. */
export const Image = ({ deviceId, ...props }: T_OptionalKeys<Props, 'deviceId'>): ReactElement =>
  deviceId ? <Guard deviceId={deviceId} {...props} /> : <Empty />;
